import type {NodeProps} from "@xyflow/react";
import OperatorNodeBase from "@/view/workflow/components/workflowGraph/node/OperatorNodeBase";
import {BranchNode} from "@/view/workflow/components/workflowGraph/types";

export function BranchOperatorNode(props: NodeProps<BranchNode>) {
    const {data} = props;
    const branches = Object.entries(data.branchMap ?? {});

    return (
        <OperatorNodeBase {...props}>
            {branches.length === 0 ? (
                <div className="py-1 text-center text-sm text-muted-foreground">
                    No Branch
                </div>
            ) : (
                <div className="mt-1 flex flex-col gap-1">
                    {/* Edge Label과 중복 노출이므로 주석 처리 필요 시 주석 제거 */}
                    {/*{branches.map(([key]) => (*/}
                    {/*    <div key={key} className="rounded-md bg-muted/50 px-2 py-1.5 text-[11px] font-medium text-muted-foreground">*/}
                    {/*        {key}*/}
                    {/*    </div>*/}
                    {/*))}*/}
                </div>
            )}
        </OperatorNodeBase>
    );
}

export default BranchOperatorNode;
